module.exports = __webpack_public_path__ + "img/操作-翻译 (1).d43da982.png";